export default {
  ESI_OWL: 1,
  ESI_FOX: 2,
  ESI_BUTTERFLY: 3,
  ESI_UNICORN: 4,
  ESI_JUG: 5,
  ESI_HORSE_SHOE: 6,
  ESI_RABBIT: 7,
  ESI_LOTUS: 8,
  ESI_SCATTER: 10,
}
